/**
 * Shared phone normalization for SMS matching and client import dedup.
 * Returns digits only (US: strips leading country code 1). Null if empty.
 * @param {string|null|undefined} phone
 * @returns {string|null}
 */
export function normalizePhone(phone) {
  if (!phone) return null;
  const digits = String(phone).replace(/[^0-9]/g, '');
  if (!digits) return null;
  return digits.length === 11 && digits.startsWith('1')
    ? digits.substring(1)
    : digits;
}

/**
 * Format normalized 10-digit US phone as (XXX) XXX-XXXX when possible.
 * Falls back to the normalized digits string.
 * @param {string|null|undefined} phone
 * @returns {string|null}
 */
export function formatPhoneDisplay(phone) {
  const digits = normalizePhone(phone);
  if (!digits) return null;
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return digits;
}
